import { createContext } from "react";
import {
  ApiGeneralDataResponse,
  BasicBotData,
  BotData,
  BotType,
  GetBotsDataRequest,
  QueryStatus,
  SortingOrder,
} from "@shared/types";
import { MyBotsSort } from "@shared/features/bots/types";
import { SkipToken } from "@reduxjs/toolkit/query";

export const MyBotsPageContext = createContext<
  | {
      active?: boolean;
      botType: BotType;
      bots: BasicBotData[];
      unfilteredBots: BasicBotData[];
      sortOptions: MyBotsSort[];
      sortBy: MyBotsSort;
      setSortBy: (sortBy: MyBotsSort) => void;
      sortDirection: SortingOrder;
      setSortDirection: (sortDirection: SortingOrder) => void;
      isFetching?: boolean;
      isChannelConfiguration?: boolean;
      isPublicBots?: boolean;
      getBotsDataStatus: QueryStatus<
        ApiGeneralDataResponse<BotData[] | BasicBotData[]>
      >;
      getBotsDataArgs: GetBotsDataRequest | SkipToken;
    }
  | undefined
>(undefined);
